import {Icon, IconNode} from "lucide-react";
import React from "react";


const PlusIconNode: IconNode = [
    [
        "path",
        {
            d: "M5 8C5 6.93913 5.42143 5.92172 6.17157 5.17157C6.92172 4.42143 7.93913 4 9 4C10.0609 4 11.0783 4.42143 11.8284 5.17157C12.5786 5.92172 13 6.93913 13 8C13 9.06087 12.5786 10.0783 11.8284 10.8284C11.0783 11.5786 10.0609 12 9 12C7.93913 12 6.92172 11.5786 6.17157 10.8284C5.42143 10.0783 5 9.06087 5 8ZM2 19.0719C2 15.9937 4.49375 13.5 7.57188 13.5H10.4281C13.5063 13.5 16 15.9937 16 19.0719C16 19.5844 15.5844 20 15.0719 20H2.92813C2.41563 20 2 19.5844 2 19.0719ZM21.0406 20H16.7344C16.9031 19.7063 17.0031 19.3656 17.0031 19V18.75C17.0031 16.8531 16.1562 15.15 14.8219 14.0063C14.8969 14.0031 14.9688 14 15.0437 14H16.9625C19.7437 14 22 16.2562 22 19.0406C22 19.5719 21.5688 20 21.0406 20ZM15.5 12C14.5312 12 13.6562 11.6063 13.0219 10.9719C13.6375 10.1406 14 9.1125 14 8C14 7.1625 13.7938 6.37188 13.4281 5.67813C14.0094 5.25312 14.725 5 15.5 5C17.4344 5 19 6.56562 19 8.5C19 10.4344 17.4344 12 15.5 12Z",
            fill: "#5C5C5C",
            key: "path0UserGroup" // Optional
        }
    ]
];

interface PlusProps {
    size?: string | number; // Optional size prop for the icon
}

export default function UserGroup({ size }: PlusProps) {
    return (
        <Icon iconNode={PlusIconNode} size={size} color="transparent" />
    );
}
